import { useEffect, useState, useRef } from "react";
import { validateExhibitor } from "../validation";
import { getImageUrl } from "utils/imageHelper";


export const useExhibitorForm = (initialData, selectedOrganizer, userId, alert, setAlert) => {

  const [existingLogo, setExistingLogo] = useState(null); 
  const [existingBanner, setExistingBanner] = useState(null);  

  const [formData, setFormData] = useState({
    title: "",
    overview: "",
    phone_number: "",
    country_code: "+91",
    email: "",
    password: "",
    country: "",
    website: "",
    manager_name: "",
    manager_email: "",
    exhibitor_category: "",
    status: "active",
    eco_friendly: false,
    logoImage: null,
    bannerImage: null,
    company_id: "",
    created_by: "",  
    updated_by: "", 
  });

  const [errors, setErrors] = useState({});

  const alertRef = useRef(null);

  useEffect(() => {
  if (initialData) {
    setFormData((prev) => ({
      ...prev,
      ...initialData,
      logoImage: null,
      bannerImage: null,
      company_id: selectedOrganizer || initialData.company_id || "",
      created_by: initialData.created_by || userId,  
      updated_by: userId,  
    }));
    setExistingLogo(initialData.logo_image ? getImageUrl(initialData.logo_image) : null);
    setExistingBanner(initialData.banner_image ? getImageUrl(initialData.banner_image) : null);
  } else {
    setFormData((prev) => ({
      ...prev,
      company_id: selectedOrganizer || "",
      created_by: userId,
      updated_by: userId,
    }));
  }
}, [initialData, selectedOrganizer, userId]);

useEffect(() => {
    if (alert && alertRef.current) {
      alertRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [alert]);


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((p) => ({
      ...p,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleFile = (e) => {
    const file = e.target.files?.[0];
    const name = e.target.name;

    if (!file) return;

    const allowedTypes = ["image/jpeg", "image/png"];
    if (!allowedTypes.includes(file.type)) {
      setErrors((p) => ({
        ...p,
        [name]: "Only JPEG and PNG files are allowed",
      }));
      return;
    }

    const img = new Image();
    img.src = URL.createObjectURL(file);

    img.onload = () => {
      let requiredWidth = 0;
      let requiredHeight = 0;

      if (name === "bannerImage") {
        requiredWidth = 393;
        requiredHeight = 219;
      }

      if (name === "logoImage") {
        requiredWidth = 120;
        requiredHeight = 40;
      }

      // if (img.width !== requiredWidth || img.height !== requiredHeight) {
      //   setErrors((p) => ({
      //     ...p,
      //     [name]: `Image must be exactly ${requiredWidth} × ${requiredHeight} px`,
      //   }));
      //   return;
      // }

      setFormData((p) => ({
        ...p,
        [name]: file,
      }));

      setErrors((p) => ({
        ...p,
        [name]: "",
      }));
    };
  };

  const handleSubmit = (onSubmit) => async (e) => {
    e.preventDefault();

    const validationErrors = validateExhibitor(formData, Boolean(initialData));

    if (Object.keys(validationErrors).length) {
      setErrors(validationErrors);
      setAlert("Please fix the highlighted errors");
      return;
    }

    const fd = new FormData();
    Object.entries(formData).forEach(([k, v]) => {
      if (v !== null && v !== undefined) {
        if (typeof v === "boolean") {
          fd.append(k, v.toString());
        } else {
          fd.append(k, v);
        }
      }
    });

    setErrors({});
    setAlert("");
    await onSubmit(fd);
  };

  return {
    formData,
    errors,
    handleChange,
    handleFile,
    handleSubmit,
    existingLogo,
    existingBanner
  };
};